import axios from "axios";
import DefaultGetConfig from "../../../../utils/defaultGetConfig";

function getCarVersions(authToken, marca, anio, modelo) {
    let carModelsConfig = DefaultGetConfig(authToken);
    carModelsConfig.params = {
        ...carModelsConfig.params,
        marca: marca,
        anio: anio,
        modelo: modelo
    }
    let carVersionsUrl = process.env.REACT_APP_BACK_SERVER + '/getVersionesAutos'
    return axios.get(carVersionsUrl, carModelsConfig);
}

export default getCarVersions;